import { ConsentDataResourceScope, ConsentDataSensitivityScope } from "healthex-common/consentscopes.dtos";
import { willNeverHappen } from "healthex-common/utils";
import { getObservableT } from "../Infra/i18next";
const t = getObservableT("common");
export function resourceScopeDescription(resourceScope) {
    switch (resourceScope) {
        case ConsentDataResourceScope.CONTACT_INFO:
            return t("Contact info");
        case ConsentDataResourceScope.MEDICATIONS:
            return t("Medications");
        case ConsentDataResourceScope.ALLERGIES:
            return t("Allergies");
        case ConsentDataResourceScope.DIAGNOSES:
            return t("Diagnoses");
        case ConsentDataResourceScope.LABS:
            return t("Labs");
        case ConsentDataResourceScope.DEMOGRAPHICS:
            return t("Demographics");
        case ConsentDataResourceScope.CLINICAL_NOTES:
            return t("Clinical notes");
        case ConsentDataResourceScope.VISITS:
            return t("Visits");
        case ConsentDataResourceScope.DIAGNOSTIC_REPORTS:
            return t("Diagnostic reports");
        case ConsentDataResourceScope.CLINICAL_VITALS:
            return t("Clinical vitals");
        case ConsentDataResourceScope.PROCEDURES:
            return t("Procedures");
        case ConsentDataResourceScope.IMMUNIZATIONS:
            return t("Immunizations");
        case ConsentDataResourceScope.IMAGING:
            return t("Imaging");
        case ConsentDataResourceScope.TREATMENT_PLAN:
            return t("Treatment plans");
        case ConsentDataResourceScope.GENOMIC_DATA:
            return t("Genomic data");
        case ConsentDataResourceScope.FAMILY_HISTORY:
            return t("Family history");
        case ConsentDataResourceScope.SOCIAL_HISTORY:
            return t("Social history");
        case ConsentDataResourceScope.ADMINISTRATIVE_AND_BILLING:
            return t("Administrative and billing");
    }
    return willNeverHappen(resourceScope);
}
export function sensitivityScopeDescription(sensitivityScope) {
    switch (sensitivityScope) {
        case ConsentDataSensitivityScope.NORMAL:
            return null;
        case ConsentDataSensitivityScope.HIV_OR_STI:
            return t("HIV / STI data");
        case ConsentDataSensitivityScope.SUBSTANCE_USE_OR_DRUG_ABUSE:
            return t("Substance use / drug abuse data");
        case ConsentDataSensitivityScope.MENTAL_HEALTH:
            return t("Mental health data");
        case ConsentDataSensitivityScope.GENETIC_TESTING:
            return t("Genetic testing results");
        case ConsentDataSensitivityScope.REPRODUCTIVE_HEALTH_DATA:
            return t("Reproductive health data");
        case ConsentDataSensitivityScope.PSYCHOTHERAPY_NOTES:
            return t("Psychotherapy notes");
        case ConsentDataSensitivityScope.SUD_PART_2:
            return t("SUD Part 2 data");
        case ConsentDataSensitivityScope.SICKLE_CELL:
            return t("Sickle cell data");
    }
    return willNeverHappen(sensitivityScope);
}
export function fullRecordWithoutRestrictedDataDescription() {
    return t("Full patient record");
}
export function fullRecordWithoutRestrictedDataSubDescription() {
    return t("Any patient data, including sensitive data if applicable, with the exclusion of SUD Part 2 data and Psychotherapy notes, which require additional consent.");
}
